<script>
	export let fontSize = 'text-2.5xl xl:text-4.5xl tracking-normal'
	export let fontWeight = 'font-extrabold'
	export let margin = 'mt-6'
	export let cls = null
	export let level = 1
	const tag = ['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
</script>

<svelte:element this={tag[level] ?? tag[1]} class="{fontSize} {fontWeight} {margin} {cls}">
	<slot />
</svelte:element>
